import { render, staticRenderFns } from "./seaportSelect.vue?vue&type=template&id=b4d3f4d8&scoped=true"
import script from "./seaportSelect.vue?vue&type=script&lang=js"
export * from "./seaportSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d3f4d8",
  null
  
)

export default component.exports